var _excluded = ["excludeHolidays", "minDate", "maxDate", "weekDays", "yearsRange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { eachMonthOfInterval } from 'date-fns';
import { useCallback } from 'react';
import { useIntl } from '../../../../../theme/i18n';
import { createDate } from '../../../../../utils';
import { createActiveMonth } from '../../utilities/createActiveMonth';
import { getPartialWeeks } from '../../utilities/getPartialWeeks';
import { useDaysUtilities } from './useDaysUtilities';

var isMonthDisabled = props => {
  var isBeforeMinDate = props.isBeforeMinDate(props.activeMonth.date);
  var isAfterMaxDate = props.isAfterMaxDate(props.activeMonth.date);

  if (isBeforeMinDate || isAfterMaxDate) {
    var monthWeeks = getPartialWeeks(props);
    var areAllWeeksDisabled = monthWeeks.every(week => week.every(day => day === null || (day === null || day === void 0 ? void 0 : day.isDisabled)));
    return areAllWeeksDisabled;
  }

  return false;
};

export var useYears = _ref => {
  var _props$selectedDate;

  var {
    excludeHolidays,
    minDate,
    maxDate,
    weekDays,
    yearsRange = 100
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    formatDate
  } = useIntl();
  var today = createDate();
  var mainDate = createActiveMonth((_props$selectedDate = props.selectedDate) !== null && _props$selectedDate !== void 0 ? _props$selectedDate : today);
  var minDateRange = minDate ? mainDate.year - createActiveMonth(minDate).year : yearsRange;
  var maxDateRange = maxDate ? mainDate.year - createActiveMonth(maxDate).year : yearsRange;
  var {
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  } = useDaysUtilities({
    excludeHolidays,
    minDate,
    maxDate,
    weekDays
  });
  var getMonthsOfYear = useCallback(year => {
    var monthsArray = eachMonthOfInterval({
      start: createDate("".concat(year, "-01-01")),
      // January 1st
      end: createDate("".concat(year, "-12-31")) // December 31st

    }); // Format each month to get the month selection type

    return monthsArray.map(m => ({
      date: m,
      label: formatDate(createActiveMonth(m).date, {
        month: 'short'
      }),
      fullLabel: formatDate(createActiveMonth(m).date, {
        month: 'long'
      }),
      isDisabled: isMonthDisabled(_objectSpread(_objectSpread({
        activeMonth: createActiveMonth(m)
      }, props), {}, {
        isBeforeMinDate,
        isAfterMaxDate,
        isHoliday,
        isInWeekDays
      }))
    }));
  }, [formatDate, props, isBeforeMinDate, isAfterMaxDate, isHoliday, isInWeekDays]);

  var getYearData = year => {
    var months = getMonthsOfYear(year);
    return {
      year,
      months,
      isDisabled: months.every(m => m.isDisabled)
    };
  };

  var getYearsRange = middleYear => {
    var yearsBefore = Array.from({
      length: minDateRange
    }, (_, index) => getYearData(middleYear - minDateRange + index));
    var yearsAfter = Array.from({
      length: maxDateRange
    }, (_, index) => getYearData(middleYear + 1 + index));
    return [...yearsBefore, getYearData(middleYear), ...yearsAfter];
  };

  var getYears = middleYear => {
    var years = getYearsRange(middleYear);
    return years.reduce((acc, yearObj) => {
      acc[Number(yearObj.year)] = yearObj;
      return acc;
    }, {});
  };

  return getYears(mainDate.year);
};
//# sourceMappingURL=useYears.js.map